import { AppType } from "@libs/common-lab/src/modals/lab.model";
export const environment = {
  appType: AppType.LAB,
  production: false,
  version: '0.0.115',
  APIURL: 'https://cloudlabs-qa-old-v2-fgebergrbxebcmgs.centralus-01.azurewebsites.net/api/',
  BASEURL: 'https://experience-qa-v2.cloudlabs.ai',
  partnerNameNarratorDialog:"Worldwide Learning",
  pollIntervalInMinutes: 1,
  extendingLabDurationInMinutes: 15,
  SIDEBAR_MIN_WIDTH: 500,
  VM_MIN_WIDTH: 768,
  EMAIL_PATTERN: '^[a-zA-Z0-9.!#$%&\'*+/=?^_’`"{|}()~-]+@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([A-Za-z]{2,40}(?:\\.[A-Za-z]{2,40})?)$',
  GTMID: '', /* ToDo: need to update */
  appInsightConfig: {
    instrumentationKey: 'e19f21f8-dab7-4c95-a4b7-3f629ba9a2ed',
    enableAutoRouteTracking: true,
    loggingLevelConsole: 1,
    autoTrackPageVisitTime: true,
    isBrowserLinkTrackingEnabled: true,
    enableRequestHeaderTracking: true,
    enableAjaxErrorStatusText: true,
  },
  privateRepoAccessToken:"665KtaNHcpUntucn5xJmciKe",
  clarityId: 'o5mc801xmi',
};
